import { loginAPI, logoutAPI, getUserInfoAPI } from '@/plugins/api'
import { setToken, getToken, removeToken } from '@/store/authtoken'
import { ActionContext } from 'vuex'
import { GetterTree } from 'vuex'

// import { RootState } from '@/store' // 假设你有根状态类型定义
export interface UserInfo {
  id: string | number;
  name: string;
  permissions?: string[];
  roles?: string[];
  // 根据实际需求补充其他字段
}
export interface AuthState {
  token: string;
  userInfo: UserInfo | null;
  studentInfo: object | null;
}
export interface LoginForm {
  phone: string;
  code: string;
}

// 定义根状态类型
export interface RootState {
  // 其他模块的状态...
  auth?: AuthState;
}
export interface StudentInfo extends UserInfo {
  // 可根据需要添加额外字段
  ageRadio?: string;
  examsTypeList: any[];
}

const state = {
//   token: getToken() || '',
  userInfo: null,
}

const mutations = {
  SET_TOKEN: (state: AuthState, token: string) => {
    state.token = token
  },
  SET_USER_INFO: (state: AuthState, userInfo: UserInfo) => {
    state.userInfo = userInfo
  },
  CLEAR_AUTH: (state: AuthState) => {
    state.token = ''
    state.userInfo = null
    state.studentInfo = null
    window.localStorage.removeItem('')
  },
  SET_STUDENT_INFO: (state: AuthState, studentInfo: UserInfo) => {
    state.studentInfo = studentInfo
  },
  UPDATE_STUDENT_INFO: (state: AuthState, payload: Partial<StudentInfo>) => {
    if (!state.studentInfo) {
      state.studentInfo = { ...payload }
    } else {
      state.studentInfo = {
        ...state.studentInfo,
        ...payload
      }
    }
  },
}

const actions = {
  // 登录
async login({ commit }: ActionContext<AuthState, RootState>, loginForm: LoginForm) {
      const response:any = await loginAPI(loginForm)
      console.log(response, 'responsedengluhshsh');
      commit('SET_USER_INFO', response.sessionData)
      return response
  },

  // 获取用户信息
  async getUserInfo({ commit }: ActionContext<AuthState, RootState>) {
    try {
      const response = await getUserInfoAPI()
      const userInfo:any = response
      commit('SET_USER_INFO', userInfo)
      if (userInfo.phone) {
        localStorage.setItem('phone', userInfo.phone )
      } else {
        localStorage.removeItem('phone')
      }
      return userInfo
    } catch (error) {
      localStorage.removeItem('phone')
      // throw error
    }
  },

  // 登出
  async logout({ commit }: ActionContext<typeof state, RootState>) {
    try {
      await logoutAPI()
      commit('CLEAR_AUTH')
      window.localStorage.removeItem('phone')
    } catch (error) {
    } finally {
      // 无论如何都清除本地状态
      removeToken()
      commit('CLEAR_AUTH')
    }
  },

  // 初始化登录状态（应用启动时调用）
  initAuth({ commit, dispatch }: ActionContext<typeof state, RootState>) {
    const token = getToken()
    if (token) {
      commit('SET_TOKEN', token)
      // 可以在这里获取用户信息
      dispatch('getUserInfo').catch(() => {
        removeToken()
        commit('CLEAR_AUTH')
      })
    } else {
      commit('CLEAR_AUTH')
    }
  },
  updateStudentPartial({ commit }: ActionContext<AuthState, RootState>, payload: Partial<StudentInfo>) {
    commit('UPDATE_STUDENT_INFO', payload)
  },
}

const getters: GetterTree<AuthState, RootState> = {
  token: (state: AuthState) => state.token,
  userInfo: (state: AuthState) => state.userInfo,
  studentInfo: (state: AuthState) => state.studentInfo
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}